// dbo.ActivityAppType — 2 is the web app.
export const WEB_APP_TYPE_ID = 2;

// The API rejects anything larger, so a bigger buffer is split.
export const MAX_ACTIVITY_ITEMS = 200;

// How long after a resource is closed the row is posted. Long enough that
// closing several in a row batches into one request, short enough that a
// single close still lands while the user is still on the page.
export const FLUSH_AFTER_CLOSE_MS = 2_000;

// Backstop sweep for anything the close path did not already send. Activities are also flushed when the page is
// hidden or unloaded, so this only bounds how much a browser crash can lose.
export const ACTIVITY_FLUSH_INTERVAL_MS = 30_000;
